<div
    ngbDropdown
    class="anc-cdr"
    container="body"
    [placement]="popupAlign === 'right' ? 'bottom-end' : 'bottom-start'"
    [popperOptions]="popperOptions"
    (openChange)="onDropdownOpenChange($event)"
>
    <button
        #trigger
        type="button"
        class="anc-cdr__trigger"
        [class.anc-cdr__trigger--small]="size === 'small'"
        ngbDropdownToggle
        [attr.aria-label]="('Date range' | translate) + ': ' + (displayText | translate)"
    >
        <i class="icon icon-calendar anc-cdr__trigger-icon" aria-hidden="true"></i>
        <span class="anc-cdr__trigger-text">{{ displayText | translate }}</span>
        <i class="icon icon-chevron-down anc-cdr__trigger-caret" aria-hidden="true"></i>
    </button>

    <lib-anc-date-picker
        #picker
        class="anc-cdr__hidden-picker"
        variant="filter"
        filterDisplay="input"
        [popupAlign]="popupAlign"
        [dateRangeValue]="displayValue"
        size="small"
        [maxDate]="maxDate"
        [isInvalidDate]="isInvalidDate"
        [showDropdowns]="true"
        [showCancel]="true"
        [linkedCalendars]="true"
        (dateRangeValueChange)="onCalendarApplied($event)"
    ></lib-anc-date-picker>

    <div
        ngbDropdownMenu
        class="anc-cdr__menu"
        [style.--anc-cdr-menu-width]="menuWidth ? menuWidth + 'px' : null"
    >
        <button
            *ngFor="let preset of presets"
            type="button"
            ngbDropdownItem
            class="anc-cdr__item"
            [class.anc-cdr__item--active]="activePreset === preset.id"
            [attr.aria-current]="activePreset === preset.id"
            (click)="onPresetClick(preset.id)"
        >
            <span>{{ preset.label | translate }}</span>
        </button>
        <button
            type="button"
            ngbDropdownItem
            class="anc-cdr__item"
            [class.anc-cdr__item--active]="isCustomRangeActive"
            [attr.aria-current]="isCustomRangeActive"
            (mousedown)="onCustomRangeClick($event)"
        >
            <span translate>Custom Date Range</span>
        </button>
    </div>
</div>
